import { NewspaperIcon, PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ChangelogsTable } from '@admin/components/changelogs/changelogs-table.tsx';
import { LinkProtected } from '@r/components/link-protected/link-protected.tsx';
import { Button } from '@ui/button.tsx';
import { Card, CardContent } from '@ui/card.tsx';

/**
 * Page Mega Admin permettant de créer, modifier et supprimer les entrées de changelog
 * (« Gestion des nouveautés »). La création se fait sur une page dédiée.
 */
export function Changelogs() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <h1 className="text-4xl font-bold">{t('fiddy.admin.changelog.page.title')}</h1>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-start gap-3">
            <NewspaperIcon className="mt-0.5 size-5 shrink-0 text-primary" />
            <div className="space-y-1">
              <h2 className="font-semibold">{t('fiddy.admin.changelog.create.card.title')}</h2>
              <p className="text-sm font-light text-muted-foreground">
                {t('fiddy.admin.changelog.create.card.description')}
              </p>
            </div>
          </div>

          <LinkProtected to="/fiddy-admin/ressources/changelogs/new" className="mt-4 inline-block">
            <Button type="button">
              {t('fiddy.admin.changelog.create.button')}
              <PlusIcon className="size-4" />
            </Button>
          </LinkProtected>
        </CardContent>
      </Card>

      <section className="space-y-5 pt-10">
        <h2 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          {t('fiddy.admin.changelog.list.title')}
        </h2>
        <ChangelogsTable />
      </section>
    </div>
  );
}
